import React, { useState } from 'react';
import { CartDownloadBtn, ClearCartBtn } from './CartWizard.elements';
import { useCart } from 'selectors';
import { useDispatch } from 'react-redux';
import { cartActions } from 'actions';
import { useTranslation } from 'react-i18next';
import { useLanguage } from 'providers';
import { IconTextBtn } from 'components/RibbonComponent';
import { IcoDownload } from 'icons/indexed-icons/IcoDownload';
import { ButtonText } from 'pages/MachineManagement/NewMachine/DataQualityStyledComponents';
import CustomLoader from 'components/CustomLoader';
import { CartPriceType, getSelectedCartState, removeOrderedItem } from './helper';
import { useWizard } from 'react-use-wizard';
import ClearCart from 'icons/indexed-icons/ClearCart';
import ConfirmationModal from 'common/components/ConfirmationModal';
import Typography from 'components/Typography/Typography';
import TriangleWarning from 'icons/indexed-icons/TriangleWarning';

interface Props {
  //   stepFooters: WizardFooterProps[];
  onDownloadDraftPO?: () => void;
  downloadDraftPDFLoader?: boolean;
  selectedCartPriceType?: CartPriceType;
}

const CartDownload = ({
  onDownloadDraftPO,
  downloadDraftPDFLoader,
  selectedCartPriceType
}: Props): JSX.Element => {
  const cartStore = useCart();
  const cart = getSelectedCartState(cartStore, selectedCartPriceType);
  const { activeStep, isLastStep } = useWizard();
  const [showClearConfirmation, setShowClearConfirmation] = useState(false);

  const dispatch = useDispatch();
  const { languageId } = useLanguage();
  const { t } = useTranslation(['fpns']);

  const handleDeleteItem = () => {
    removeOrderedItem(cart.items, dispatch);
    setShowClearConfirmation(false);
  };

  const handleConfirmation = () => {
    setShowClearConfirmation(true);
  };

  return (
    <CartDownloadBtn className="btn">
      <IconTextBtn
        disable={cart?.items.length === 0}
        onClick={() => {
          if (onDownloadDraftPO) {
            onDownloadDraftPO();
          }
        }}
        gap=".2rem"
      >
        {downloadDraftPDFLoader ? (
          <CustomLoader size={'1.2rem'} thickness=".2rem" />
        ) : (
          <IcoDownload />
        )}
        <ButtonText>{t('download_draft_order_quote')}</ButtonText>
      </IconTextBtn>

      <IconTextBtn
        disable={cart?.items.length === 0}
        onClick={() => {
          cart?.items?.length &&
            dispatch({
              type: cartActions.DOWNLOAD_CART_CSV,
              t: t,
              cart,
              languageId: languageId
            });
        }}
        gap=".2rem"
      >
        <IcoDownload />
        <ButtonText>{t('download_cart_csv')}</ButtonText>
      </IconTextBtn>
      {/* </DraftPOContainer> */}
      {(activeStep === 3 || isLastStep) && (
        <ClearCartBtn>
          <ClearCart />
          <ButtonText onClick={handleConfirmation} className="delete-cart-btn">
            Delete Cart
          </ButtonText>
        </ClearCartBtn>
      )}
      {showClearConfirmation && (
        <ConfirmationModal
          isConfirmPrompt
          isVisible={showClearConfirmation}
          title={'Delete cart?'}
          headerIcon={<TriangleWarning />}
          zIndex={99999}
          onCancelCallback={() => setShowClearConfirmation(false)}
          onConfirmCallback={handleDeleteItem}
        >
          <Typography>
            Deleting the cart will delete all the items in cart. Do you want to continue?
          </Typography>
        </ConfirmationModal>
      )}
    </CartDownloadBtn>
  );
};

export default CartDownload;
